import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  output,
  signal,
} from '@angular/core';

import {
  AlertsComponent,
  AlertsService,
  PrimengButtonDirective,
} from '@web/shared/ui';
import { SignUpAsCompanyFormComponent } from '../../components/sign-up-as-company-form/sign-up-as-company-form.component';
import { FormTitleWithSubtitleComponent } from '../../ui/form-title-with-subtitle/form-title-with-subtitle.component';
import { SignUpAsCompanyForm } from '../../models/sign-up-as-company-form';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpErrorService } from '@web/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Button } from 'primeng/button';
import { SignUpService } from '../../services/sign-up.service';

@Component({
  selector: 'app-sign-up-as-company',
  imports: [
    FormTitleWithSubtitleComponent,
    SignUpAsCompanyFormComponent,
    AlertsComponent,
    Button,
    PrimengButtonDirective,
  ],
  templateUrl: './sign-up-as-company.component.html',
  styleUrl: './sign-up-as-company.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class SignUpAsCompanyComponent {
  private readonly signUp = inject(SignUpService);
  private readonly alerts = inject(AlertsService);
  private readonly httpError = inject(HttpErrorService);

  public readonly navigateToSignInPageEvent = output();

  protected readonly isFormVisible = signal<boolean>(true);

  private readonly destroyRef = inject(DestroyRef);

  public handleSubmitClickEvent(form: SignUpAsCompanyForm): void {
    this.signUp
      .signUpAsCompany(form)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.showSuccessAlert();
          this.markFormAsInvisible();
        },
        error: (response) => {
          this.showFailureAlertByResponse(response);
        },
      });
  }

  public handleNavigateToSignInPageClick(): void {
    this.navigateToSignInPageEvent.emit();
  }

  public showSuccessAlert(): void {
    this.alerts.showSingle((builder) =>
      builder
        .initSuccess(
          'Dziękujemy za założenie konta. Aby dokończyć proces rejestracji, prosimy o aktywację Twojego konta. Instrukcje dotyczące aktywacji zostały wysłane na Twój adres e-mail. Sprawdź swoją skrzynkę pocztową i postępuj zgodnie z przesłanymi informacjami.',
        )
        .closeable(false)
        .build(),
    );
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }

  private markFormAsInvisible(): void {
    this.isFormVisible.set(false);
  }
}
